import { reportsDataSelector } from "@/store/reports/selector/reportsDataSelector";
import { NotificationSlack } from "@/services/cloudchipr.api";
import { RootState } from "@/store/store";

export const reportsDataNotificationsSelector = (state: RootState) => {
  return reportsDataSelector(state)?.notifications?.at(0) as
    | NotificationSlack
    | undefined;
};
